var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "modal-header" },
      [_vm._t("header", [_c("h3", [_vm._v("Commands available")])])],
      2
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _vm._t("body", [
          _c("p", [_vm._v("Shift + Click = Toggle map complete*")]),
          _c("p", [_vm._v("Alt + Click = Toggle map shaped")]),
          _c("p", [
            _vm._v("Ctrl(Command on Mac) + Click = Alternate permanent sextant")
          ]),
          _vm._m(0),
          _c("h4", [_vm._v("Search commands")]),
          _c("p", [_vm._v("Tier: X = finds all maps of this tier")]),
          _c("p", [
            _vm._v(
              "complete:X = Press enter to complete all the maps in this tier"
            )
          ]),
          _c("p", [
            _vm._v(
              "uncomplete:X = Press enter to uncomplete all the maps in this tier"
            )
          ]),
          _c("br"),
          _c("p", [
            _vm._v(
              "To search for a map just type the name(even without spaces). You can then press enter to center on it."
            )
          ])
        ])
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _vm._t("header", [
          _c(
            "button",
            {
              staticClass: "modal-default-button",
              on: {
                click: function($event) {
                  _vm.$emit("close_modal")
                }
              }
            },
            [_vm._v("Close")]
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("i", [
        _vm._v("*Making a map in-complete will block it from having sextants.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-419d4f32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-419d4f32","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CommandsHelp.vue
// module id = 63
// module chunks = 0